export const mapRoles = {
  jbcc_supervisor: "JBCC Supervisor",
  jbcc_factory: "JBCC Factory",
  jn_field: "JN Field",
  jbcc_admin: "JBCC Admin",
  jbcc_field: "JBCC Field",
  jbcc_factory_supervisor: "JBCC Factory Supervisor",
  jn_admin: "JN Admin",
  jn_supervisor: "JN Supervisor",
  jbcc_office: "JBCC Office",
  jbcc_accounts: "JBCC Accounts",
  jbcc_driver: "JBCC Driver",
  jbcc_super_admin: "JBCC Super Admin",
  jn_super_admin: "JN Super Admin",
  officer: "Officer",
  payroll_administrator: "Payroll Administrator",
  office_process_analyst: "Office Process Analyst",
  salary_adder: "Salary Adder",
  salary_deductor: "Salary Deductor",
  jobcard_reviewer: "Job Card Reviewer",
  damage_valve_checker: "Damage Valve Checker",
  cap_present_checker: "Cap Present Checker",
  cylinder_color_checker: "Cylinder Color Checker",
  leakage_color_checker: "Leakage Color Checker",
  wear_tear_checker: "Wear Tear Checker",
  sandblast_required_checker: "Sandblast Required Checker",
  gas_found_checker: "Gas Found Checker",
  weight_before_degas_checker: "Weight Before Degass Checker",
  degassing_checker: "Degassing Checker",
  weight_after_degas_checker: "Weight After Degass Checker",
  last_hydro_date_checker: "Last Hydro Date Checker",
  hydro_required_checker: "Hydro Required Checker",
  original_weight_checker: "Original Weight Checker",
  valve_dismantling_checker: "Valve Dismantling Checker",
  cylinder_inversion_checker: "Cylinder Inversion Checker",
  slug_found_checker: "Slug Found Checker",
  slug_cleaning_checker: "Slug Cleaning Checker",
  water_found_checker: "Water Found Checker",
  water_cleaning_checker: "Water Cleaning Checker",
  rejected_valve_fit_checker: "Rejected Valve Fit Checker",
  tare_weight_checker: "Tare Weight Checker",
  hydro_testing_checker: "hydro Testing Checker",
  sandblast_done_checker: "Sandblast Done Checker",
  paint_done_checker: "Paint Done Checker",
  valve_fitting_checker: "Valve Fitting Checker",
  vacuum_checker: "Vacuum Checker",
  filling_checker: "Filling Checker",
  ammonia_temp_checker: "Ammonia Temp Checker",
  ammonia_temp_2hr_checker: "Ammonia Temp 2hr Checker",
  cap_fit_checker: "Cap Fit Checker",
  final_check_checker: "Final Check Checker",
  PARTIAL_SUPER_ADMIN: "Partial Super Admin",
  factory_head: "Factory Head",
};
